import { ServiceOwner } from 'types/api/services/service'
import { PolicyCategory, PolicyEvaluation, PolicyTarget } from 'types/policy'

export interface ReliabilityCategorySummary {
  category: PolicyCategory
  policyTarget: PolicyTarget
  policyStates: PolicyEvaluation[]
  score: number
  maxScore: number
  rank: number // Denotes the place of the PolicyCategory
}

export interface ReliabilityReport {
  reliability: Record<PolicyCategory, ReliabilityCategorySummary>
  score: number
  maxScore: number
}

export interface ServiceStatsByDate {
  trackingDate: Date | string
  score: number
  numOfServices: number
}

export interface ReliabilityReportTrendData {
  start: Date | string
  end: Date | string
  numOfDataPoints: number
  statsByDate: ServiceStatsByDate[]
}

export interface CompanyReliabilityReportServicesResponse {
  services: ServiceReportResponse[]
}

export interface ServiceReportResponse {
  serviceId: string
  serviceName: string
  lastModified: string
  serviceOwner?: ServiceOwner
  teamOwner: ServiceReportTeamOwnerDetails
  score: number
  trendType: ServiceReportTrendType
  delta: number
  inTopList: boolean //to show tropy and different UI affodance in list view
  includeDailyReport: boolean
  dailyReportsForTimeWindow: ReliabilityReport[] //Only populated if includeDailyReport query param is true. Natalie was suggesting we might need this.
  reliabilityReportTrend: ReliabilityReportTrendData
}

export interface ServiceReportTeamOwnerDetails {
  teamId: string
  teamName: string
  teamOwnerEmail: string
  teamOwnerName: string
}

export interface CompanyReliabilityReportServicesSummaryResponse {
  start?: Date | string
  end?: Date | string
  topN: int //default 3
  biggestChangers: Partial<ServiceReportResponse>[]
}

export type ServiceReportTrendType = 'Up' | 'Down' | 'NoChange'

export enum ServicesGroup {
  TEAM = 'TEAM',
  NONE = 'NONE'
}

export interface ServiceGroupDetails {
  name: string
  id: string
  ownerDetails: ServiceOwner
}

export interface GroupedServicesResponse {
  groupDetails: ServiceGroupDetails
  numOfServices: number
  avgScore: number
}

export interface CompanyReliabilityReportGroupedServicesResponse {
  groupBy: ServicesGroup
  groupedServices: GroupedServicesResponse[]
}
